import { FormattedMessage } from "react-intl";
import { useState } from "react";
import HelpDialogSwitcher from "../common/help/HelpDialogSwitcher.tsx";
import EmptyState from "../common/empty-state/EmptyState.tsx";
import { useBrandLoaderData } from "routes/root/rootLoader.ts";

function Graphic() {
  return (
    <svg
      width="351"
      height="181"
      viewBox="0 0 351 181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      focusable={false}
    >
      <g clipPath="url(#clip0_3383_66466)">
        <path
          d="M122.56 1.5H163.14"
          stroke="#425B9F"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M1.5 108.07V123.35"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M172.43 1.5H190.06"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M348.7 39.76H329.89"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M340.34 19.16L327.04 32.46"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M319.94 9.75V28.56"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M30.74 163.07H8.66C4.71 163.07 1.5 159.87 1.5 155.91V133.92"
          stroke="#425B9F"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M220.22 10.64H110.8C107.845 10.64 105.45 13.0353 105.45 15.99V175.17C105.45 178.125 107.845 180.52 110.8 180.52H220.22C223.175 180.52 225.57 178.125 225.57 175.17V15.99C225.57 13.0353 223.175 10.64 220.22 10.64Z"
          fill="#F0F2F7"
        />
        <path
          d="M201.06 28.27H129.97C127.015 28.27 124.62 30.6653 124.62 33.62V121.67C124.62 124.625 127.015 127.02 129.97 127.02H201.06C204.015 127.02 206.41 124.625 206.41 121.67V33.62C206.41 30.6653 204.015 28.27 201.06 28.27Z"
          fill="#D0D7EB"
        />
        <path
          d="M201.06 142.75H129.97C127.015 142.75 124.62 145.145 124.62 148.1V149.83C124.62 152.785 127.015 155.18 129.97 155.18H201.06C204.015 155.18 206.41 152.785 206.41 149.83V148.1C206.41 145.145 204.015 142.75 201.06 142.75Z"
          fill="#D0D7EB"
        />
        <path
          d="M89.44 37.42H14.5C12.4786 37.42 10.84 39.0586 10.84 41.08V150.1C10.84 152.121 12.4786 153.76 14.5 153.76H89.44C91.4614 153.76 93.1 152.121 93.1 150.1V41.08C93.1 39.0586 91.4614 37.42 89.44 37.42Z"
          fill="#F0F2F7"
        />
        <path
          d="M76.32 49.48H27.63C25.6086 49.48 23.97 51.1186 23.97 53.14V113.45C23.97 115.471 25.6086 117.11 27.63 117.11H76.32C78.3414 117.11 79.98 115.471 79.98 113.45V53.14C79.98 51.1186 78.3414 49.48 76.32 49.48Z"
          fill="#D0D7EB"
        />
        <path
          d="M76.32 127.89H27.63C25.6086 127.89 23.97 129.529 23.97 131.55V132.74C23.97 134.761 25.6086 136.4 27.63 136.4H76.32C78.3414 136.4 79.98 134.761 79.98 132.74V131.55C79.98 129.529 78.3414 127.89 76.32 127.89Z"
          fill="#D0D7EB"
        />
        <path
          d="M317.2 37.1211H242.26C240.239 37.1211 238.6 38.7597 238.6 40.7811V149.801C238.6 151.822 240.239 153.461 242.26 153.461H317.2C319.221 153.461 320.86 151.822 320.86 149.801V40.7811C320.86 38.7597 319.221 37.1211 317.2 37.1211Z"
          fill="#F0F2F7"
        />
        <path
          d="M304.07 49.18H255.38C253.359 49.18 251.72 50.8186 251.72 52.84V113.15C251.72 115.171 253.359 116.81 255.38 116.81H304.07C306.091 116.81 307.73 115.171 307.73 113.15V52.84C307.73 50.8186 306.091 49.18 304.07 49.18Z"
          fill="#D0D7EB"
        />
        <path
          d="M304.07 127.59H255.38C253.359 127.59 251.72 129.228 251.72 131.25V132.44C251.72 134.461 253.359 136.1 255.38 136.1H304.07C306.091 136.1 307.73 134.461 307.73 132.44V131.25C307.73 129.228 306.091 127.59 304.07 127.59Z"
          fill="#D0D7EB"
        />
      </g>
      <defs>
        <clipPath id="clip0_3383_66466">
          <rect width="368.19" height="180.52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function EmptyLibrary() {
  const brand = useBrandLoaderData();
  const [isShowingHelp, setIsShowingHelp] = useState(false);

  return (
    <>
      {brand.MyLibraryBanner.enabled && (
        <EmptyState
          graphic={<Graphic />}
          title={
            <FormattedMessage defaultMessage="Quickly Access Your Content" />
          }
          body={
            <FormattedMessage defaultMessage="Not seeing what you expect? You may need to redeem a code or double check the email associated with your VitalSource account." />
          }
          buttonProps={{
            onClick: () => setIsShowingHelp(true),
            children: <FormattedMessage defaultMessage="Learn More" />,
          }}
        />
      )}
      {isShowingHelp && (
        <HelpDialogSwitcher onRequestClose={() => setIsShowingHelp(false)} />
      )}
    </>
  );
}
